import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import {
  removeReadOnlyFields,
  timestampToDate,
  unNullifyArrays,
} from 'src/utils/fieldNormalizers';

import { Trainer } from './_types';

const arrayKeys = [
  'tags',
  'reportsRole',
  'disabledTabs',
  'disabledDashboardBoxes',
  'disabledDashboardNotifications',
  'disabledEmails',
  'disabledDashboardKpis',
  'disabledDashboardCharts',
  'disabledTasks',
  'headTrainerEmails',
];

const readOnlyFields = [
  'updated_at',
  'ended_at',
  'created_at',
  'tags',
];

export function normalizeTrainer(trainer: any): Trainer | null {
  const camelized = camelcaseKeys(trainer);
  if (!camelized) return camelized;

  return {
    ...unNullifyArrays(camelized, arrayKeys),
    createdAt: timestampToDate(camelized.createdAt),
    updatedAt: timestampToDate(camelized.updatedAt),
    endedAt: timestampToDate(camelized.endedAt),
  } as Trainer;
}

export function denormalizeTrainer(trainer: Partial<Trainer>): any {
  const obj = decamelizeKeys(trainer, { deep: true });

  if (obj.tags) {
    obj.tag_list = obj.tags?.join(',');
  }

  removeReadOnlyFields(obj, readOnlyFields);

  return obj;
}
